import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>🥟 Parada Predileta</h3>
          <p>Os melhores pastéis da cidade! Tradição e sabor desde sempre.</p>
        </div>
        <div className="footer-section">
          <h4>Links</h4>
          <Link to="/">Início</Link>
          <Link to="/cardapio">Cardápio</Link>
          <Link to="/localizacao">Localização</Link>
          <Link to="/contato">Contato</Link>
        </div>
        <div className="footer-section">
          <h4>Contato</h4>
          <p>📞 (XX) XXXXX-XXXX</p>
          <p>📧 contato@paradapredileta.com.br</p>
          <p>📍 Endereço da pastelaria</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Parada Predileta. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
}
